/*
 * Softeo
 *
 * Author: Anthony LEFOYE
 * Copyright (c) 2023-2024 Prodeo - All Rights Reserved
 */

const API_RIGHTS = Object.freeze( {
  GET_RIGHTS: 'get_rights',

  GET_ACCOUNTS: 'get_accounts',
  LOCK_ACCOUNTS: 'lock_accounts',
  UNLOCK_ACCOUNTS: 'unlock_accounts',
  REGISTER_ACCOUNTS: 'register_accounts',
  CHANGE_PASSWORDS: 'change_passwords',
  CHANGE_ACCOUNTS: 'change_accounts',

  GET_GROUPS: 'get_groups',
  CREATE_GROUPS: 'create_groups',
  UPDATE_GROUPS: 'update_groups',
  DELETE_GROUPS: 'delete_groups',

  GET_CUSTOMERS: 'get_customers',
  CREATE_CUSTOMERS: 'create_customers',
  UPDATE_CUSTOMERS: 'update_customers',
  DELETE_CUSTOMERS: 'delete_customers',

  GET_CUSTOMER_SITES: 'get_customer_sites',
  CREATE_CUSTOMER_SITES: 'create_customer_sites',
  UPDATE_CUSTOMER_SITES: 'update_customer_sites',
  DELETE_CUSTOMER_SITES: 'delete_customer_sites',

  GET_PRODUCTS: 'get_products',
  CREATE_PRODUCTS: 'create_products',
  UPDATE_PRODUCTS: 'update_products',
  DELETE_PRODUCTS: 'delete_products',

  GET_LICENSES: 'get_licenses',
  CREATE_LICENSES: 'create_licenses',
  UPDATE_LICENSES: 'update_licenses',
  DELETE_LICENSES: 'delete_licenses',

  GET_CONTACTS: 'get_contacts',
  CREATE_CONTACTS: 'create_contacts',
  UPDATE_CONTACTS: 'update_contacts',
  DELETE_CONTACTS: 'delete_contacts'
} );

export default API_RIGHTS;